import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PostalCodeUtilsService {
  private postalCodeRegex = /^[0-9]{5}(-)?([0-9]{3})?$/;

  isValidFormat(postalCode: string): boolean {
    return this.postalCodeRegex.test(postalCode);
  }
}
